import React, { useEffect, useState } from 'react'
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import SettingTextField from "../../../components/SettingTextField"
import { Grid, Dialog } from "@mui/material";
import { ModalModes } from "./constants";
import { set } from 'date-fns';

const GROUP_NAME_ERROR_TEXT = "Group name is already taken";
const GroupModalDialog = ({ open, onClose, groupData, mode, onSave, loading, takenGroupName }) => {
    const [groupName, setGroupName] = useState(ModalModes.ADD === mode ? "" : groupData.groupName);
    const [error, setError] = useState("");
    const [groupNameError, setGroupNameError] = useState(takenGroupName && takenGroupName === groupData.groupName ? GROUP_NAME_ERROR_TEXT : "");

    useEffect(() => {
        setGroupNameError(takenGroupName && takenGroupName === groupName ? GROUP_NAME_ERROR_TEXT : "");
    }, [takenGroupName]);

    const handleChange = (value) => {
        setGroupName(value);
        setError(value.trim() === "" ? "Group name is required" : "");
        setGroupNameError(value && value === takenGroupName ? GROUP_NAME_ERROR_TEXT : "");
    }

    const handleSaveBtnClick = () => onSave({ ...groupData, groupName });

    const handleClose = () => {
        if (loading) return;
        onClose();
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            sx={styles.mainDialog} >
            <Grid p={4}>
                <DialogTitle sx={styles.confirmTitleText}>
                    {`${mode} Group`}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" sx={styles.confirmContentText}>
                        <Grid item xs={12}>
                            <SettingTextField
                                page={"feature-list"}
                                value={groupName}
                                setValue={handleChange}
                                border={"1px solid #AAA"}
                                placeholder={""}
                                labelStyle={{ fontSize: 14, fontFamily: "GilroySemiBold", textAlign: "left" }}
                                label="Group Name"
                                variant={"filled"}
                                error={error || groupNameError}
                                errorStyles={{ textAlign: 'left' }}
                            />
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={styles.confirmBtnDialog}>
                    <Button sx={[styles.btnText, styles.noBtnText]}
                        onClick={handleClose}>
                        cancel
                    </Button>
                    <Button sx={[styles.btnText, styles.yesBtnText]}
                        disabled={loading || error || groupNameError || groupName === groupData.groupName}
                        onClick={handleSaveBtnClick}>
                        {loading ? "Processing..." : "Save"}
                    </Button>
                </DialogActions>
            </Grid>
        </Dialog>
    )
}

export default GroupModalDialog;

const styles = {
    mainDialog: {
        '& .MuiDialog-paper': {
            borderRadius: 3,
            xs: {
                width: 'calc(100% - 2rem)',
            },
            sm: {
                width: '36rem'
            },
        },
    },
    confirmTitleText: {
        fontFamily: 'GilroyBold',
        textAlign: 'center',
        fontSize: '1.5rem',
        textTransform: 'capitalize'
    },
    confirmContentText: {
        fontFamily: 'GilroyMedium',
        textAlign: 'center'
    },
    confirmBtnDialog: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        padding: '1.5rem'
    },
    btnText: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textTransform: 'capitalize',
        fontFamily: "GilroySemiBold",
        height: "2.5rem",
        padding: "0 18px",
        fontSize: "14px",
        cursor: "pointer",
        border: "2px solid #000000",
        borderRadius: "8px",
        flex: 1
    },
    noBtnText: {
        color: '#000000',
        '&:hover': {
            backgroundColor: '#ffffff !important',
        },
    },
    yesBtnText: {
        backgroundColor: '#000000',
        color: '#ffffff !important',
        borderRadius: 2,
        px: 2,
        '&:hover': {
            color: '#ffffff !important',
            backgroundColor: '#000000 !important',
        },
        '&:disabled': {
            opacity: 0.5
        }
    }
}

